export default __webpack_public_path__ + "static/media/cheatday_2@3x.0dd5f8ab.jpg";